// noinspection GraphQLUnresolvedReference

import { gqlAst } from '../../../../utils/gql.ts'
import { puntoVentaFragmentAst } from '../../../../base/fragments/puntoVentaFragment.ts'
import { sucursalFragmentAst } from '../../../../base/fragments/sucursalFragment.ts'

/**
 * Fragmento para impresoras
 * @author isi-template
 */
export const impresoraFragment = /* GraphQL*/ `
  fragment impresoraFields on Impresora {
    _id
    nombre
    descripcion
    atributo1
    sucursal {
      ...sucursalFields
    }
    puntoVenta {
      ...puntoVentaFields
    }
    atributo2
    state
  }
`
/**
 * Fragmento para impresoras
 * @author isi-template
 */
export const impresoraFragmentAst = /* GraphQL */ gqlAst`
  ${sucursalFragmentAst}
  ${puntoVentaFragmentAst}

  ${impresoraFragment}
`

/**
 * Fragmento para impresoras asignadas
 * @author isi-template
 */
export const impresoraAsignacionFragmentAst = /* GraphQL */ gqlAst`
    ${impresoraFragmentAst}
    fragment impresoraAsignacionFields on ImpresoraAsignacion {
      _id
      copias
      createdAt
      documento
      formato
      impresora {
        ...impresoraFields
      }
      impresoraId
      nombreImpresora
      puntoVenta {
        codigo
        nombre
        descripcion
      }
      sucursal {
        codigo
        alias
        direccion
        telefono
        integracionSiat
      }
      updatedAt
      usucre
      usumod
  }
`

/**
 * Fragmento para impresoras de un punto de venta
 * @author isi-template
 */
export const impresoraPuntoVentaFragmentAst = /* GraphQL */ gqlAst`
    ${impresoraFragmentAst}
    fragment impresoraPuntoVentaFields on ImpresoraPuntoVenta {
      copias
      documento
      formato
      impresora {
        ...impresoraFields
      }
      # Nombre a usar en isi-print: el de la asignación o impresora.atributo1
      nombreImpresora
      # PUNTO_VENTA | SUCURSAL
      origen
      # Documento cuya asignación se usó como respaldo (COMANDA usa PEDIDO); null si es propia
      respaldo
  }
`
